import script from "./add.vue?vue&type=script&lang=jsx"
export * from "./add.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__